export default abstract class AbstractApi {
  apiEnd: string = ''

  constructor(apiEnd: string) {
    this.apiEnd = apiEnd
  }
}
